import { useMutation, useQueryClient } from "react-query";
import { WorkspaceUpdateFileData } from "@interfaces/company/workspace";
import { workspaceService } from "@services/workspace-service";
import { workspaceQueryKeys } from "./queryKeys";

export const useUpdateWorkspaceFileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: WorkspaceUpdateFileData) => workspaceService.updateFile(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(workspaceQueryKeys.allDirectoriesFiles);
      },
    }
  );
};
